export default "__VITE_ASSET__WeKP2aDq__"